import { FacetValue } from '@models';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './checkbox-list-facet.component.hbs';
import checkboxListPartialHtml from './checkbox-list.partial.hbs';

interface CheckboxListFacetValue extends FacetValue {
    visible: boolean;
    toggled: boolean;
    hasChildren: boolean;
    children?: Array<CheckboxListFacetValue>;
}

export class CheckboxListFacetComponent extends BaseFacetComponent {
    protected override customTemplatePropertyName = 'checkboxListFacet';
    protected override defaultHtml = defaultHtml;

    protected override registerHelpers(): void {
        super.registerHelpers();

        this.handlebars.registerPartial('facet-checkbox-list', checkboxListPartialHtml);
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data || !this.data.values?.length) {
            return '';
        }

        const filterRegex = this.state.filter ? new RegExp(this.state.filter, 'i') : undefined;

        const filtered = (value: FacetValue): boolean => {
            if (!filterRegex) {
                return false;
            }

            return filterRegex.test(value.title);
        };

        const containsFiltered = (value: FacetValue): boolean => {
            return value.children?.some((v) => filtered(v)) || false;
        };

        const getValues = (values: Array<FacetValue> | undefined, parent: CheckboxListFacetValue | undefined): Array<CheckboxListFacetValue> | undefined => {
            return values?.map((v, i) => {
                const valueWithState = {
                    ...v,
                    visible:
                        (!parent && !filterRegex && (this.state.toggled || !this.data!.truncateThreshold || i < this.data!.truncateThreshold!)) ||
                        filtered(v) ||
                        containsFiltered(v) ||
                        (!filterRegex && !!parent?.toggled),
                    hasChildren: !!v.children?.length,
                    children: undefined,
                    toggled: (v.value && v.children?.length ? this.state.values?.[v.value!]?.toggled ?? false : false) || containsFiltered(v)
                };

                (valueWithState as any).children = getValues(v.children, valueWithState);

                return valueWithState;
            });
        };

        const html = template({
            values: getValues(this.data.values, undefined),
            showToggle: !!this.data.truncateThreshold && (this.data.values?.length ?? 0) > this.data.truncateThreshold && !this.state.filter,
            toggleText: this.state.toggled ? 'Show fewer' : 'Show more',
            expanded: this.state.toggled
        });

        return html;
    }
}
